function createPart(message: any, overrides: any, partIndex: number): any {
  return {
    id: overrides.id || `${message.id}-${overrides.type}`,
    role: message.role,
    partIndex,
    type: overrides.type,
    content: overrides.content || null,
    toolCall: overrides.toolCall || null,
    attachment: overrides.attachment || null,
    reasoning: null,
    usage: null,
    metadata: null,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}

export function messagesToChatParts(messages: any[]): any[] {
  return messages.reduce((memo: any[], item: any) => {
    let partIndex = memo.length;

    item.parts?.forEach((part: any) => {
      if (part.type === 'step-start') {
        return;
      }

      memo.push(
        createPart(
          item,
          {
            type: part.type === 'tool-invocation' ? 'tool_invocation' : part.type || 'text',
            content: part.text,
            toolCall: part.toolInvocation,
          },
          partIndex++
        )
      );
    });

    item.experimental_attachments?.forEach((attachment: any) => {
      memo.push(createPart(item, { type: 'attachment', attachment }, partIndex++));
    });

    return memo;
  }, []);
}
